/* tslint:disable */

declare var Object: any;
export interface YesdokserviceInterface {
  "id"?: number;
}

export class Yesdokservice implements YesdokserviceInterface {
  "id": number;
  constructor(data?: YesdokserviceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Yesdokservice`.
   */
  public static getModelName() {
    return "Yesdokservice";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Yesdokservice for dynamic purposes.
  **/
  public static factory(data: YesdokserviceInterface): Yesdokservice{
    return new Yesdokservice(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Yesdokservice',
      plural: 'Yesdokservices',
      path: 'Yesdokservices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Yesdokservice.ts